var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 pl-4 small",staticStyle:{"background-color":"#01071a","color":"#a2df2f"}},[_vm._v(" 👋🏼 Sprawdź co jeszcze mamy w ofercie. 👉🏼 "),_c('router-link',{staticClass:"text-white",attrs:{"to":'/pakiety'}},[_vm._v("Kliknij tutaj")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }